import React, { useEffect, useState } from 'react'
import MultiSelectFilter from '../../components/MultiSelectFilter';
import DataAccessManagementTable from '../../components/DataAccessManagementTable';
import ReportTypeRestrictions from '../../components/ReportTypeRestrictions';
import Filters from '../../components/MultiSelectFilter';
import { userService } from '../../services/userService';
import { dataAccessService } from '../../services/dataAccessService';

export default function AdminDataAccessControl() {

  const [dataSetAccessData, setDataSetAccessData] = useState([])
  const [reportTypeRestriction, setReportTypeRestriction] = useState({})
  const [selectedDataSetId, setSelectedDataSetId] = useState(1)
  const [selectedAccessLevel, setSelectedAccessLevel] = useState([])
  const [selectedPermission, setSelectedPermission] = useState([])
  const [allRoles, setAllRoles] = useState([])
  const [allDataSet, setAllDataset] = useState([])
  const [allAccessLevel, setAllAccessLevel] = useState([])
  const [loader, setLoader] = useState(false)
  const [reportLoader, setReportLoader] = useState(false)
  const [selectedFilters, setSelectedFilters] = useState({
    role: [],
    dataset: [],
  });
  const [selectedFiltersIds, setSelectedFiltersIds] = useState({
    role: "",
    dataset: "",
  });
  const filterConfigs = [
    { key: "role", label: "All Roles", options: allRoles, color: "blue" },
    { key: "dataset", label: "All Dataset Types", options: allDataSet, color: "green" },
  ];

  useEffect(() => {
    getRoles()
    getDataSetFilter()
    getAccessLevel()
  }, [])

  useEffect(() => {
    getAllDataSetList()
  }, [selectedFiltersIds?.role, selectedFiltersIds?.dataset])

  useEffect(() => {
    getDataSetById()
  }, [selectedDataSetId])

  const getRoles = async () => {
    try {
      let res = await userService.getAllRoles();
      if (res?.success == true) {
        setAllRoles(res?.data);
      } else {
        setAllRoles([])
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const getDataSetFilter = async () => {
    try {
      let res = await dataAccessService.getDataSetTypeForFilter();
      if (res?.success == true) {
        setAllDataset(res?.data);
      } else {
        setAllDataset([])
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };
  const getAccessLevel = async () => {
    try {
      let res = await dataAccessService.getAccessLevel();
      if (res?.success == true) {
        setAllAccessLevel(res?.data)
      } else {
        setAllAccessLevel([])
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const getAllDataSetList = async () => {
    try {
      setLoader(true)
      let data = JSON.stringify({
        'role_id': selectedFiltersIds?.role || null,
        'dataset_id': selectedFiltersIds?.dataset || null,
      })
      let response = await dataAccessService.getAllDataAccess(data)
      if (response?.success == true) {
        setLoader(false)
        setDataSetAccessData(response?.data);
      } else {
        setLoader(false)
        setDataSetAccessData([])
      }
    } catch (error) {
      setLoader(false)
      console.error("Error fetching roles:", error);
    }
  }

  const getDataSetById = async () => {
    try {
      setReportLoader(true)
      let data = JSON.stringify({
        'dataset_id': selectedDataSetId,
        'role_id': null
      })
      let response = await dataAccessService.getDataAccessById(data)
      if (response?.success == true) {
        setReportLoader(false)
        setReportTypeRestriction(response?.data)
      } else {
        setReportLoader(false)
        setReportTypeRestriction({})
      }
    } catch (error) {
      setReportLoader(false)
      console.error("Error fetching roles:", error);
    }
  }
console.log("selectedAccessLevel", selectedPermission);
const addSaveChanges = async() => {
  try {
  
    let response = await dataAccessService.updateDataAccess(selectedPermission)
    if (response?.success == true) {
      // alert("Data Access Updated Successfully")
    } else {
      // alert("Failed to update Data Access")
    }
  } catch (error) {
    console.error("Error updating data access:", error);
  }
}
  return (
    <div>
      <div className='flex items-center justify-between  p-4'>
        <div>
          <Filters filterConfigs={filterConfigs} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} selectedFiltersIds={selectedFiltersIds} setSelectedFiltersIds={setSelectedFiltersIds} />
        </div>
        <div>
          <button onClick={addSaveChanges}
          className="bg-brandBlue text-white px-4 flex gap-2 py-2 rounded-lg hover:bg-brandBlue-600 transition">
            Save Changes  </button>
        </div>
      </div>

      <DataAccessManagementTable dataSetAccessData={dataSetAccessData} setSelectedAccessLevel={setSelectedAccessLevel} allAccessLevel={allAccessLevel} loader={loader} selectedDataSetId={selectedDataSetId} setSelectedDataSetId={setSelectedDataSetId} allRoles={allRoles} />
      <ReportTypeRestrictions reportTypeRestriction={reportTypeRestriction} setSelectedPermission={setSelectedPermission} loader={reportLoader} allRoles={allRoles}/>

    </div>
  )
}
